export function getErrorMessage(message) {
  message = message?.message.replaceAll('Error:', '').trim()
  return JSON.parse(message)
}
